export const getHighlightedText = (text, highlight) => {
    if (highlight === undefined || highlight === '') return <span>{text}</span>
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span>{parts.map((part, index) => part.toLowerCase() === highlight.toLowerCase() ? <em key={index}>{part}</em> : part)}</span>;
}
